import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EditorState } from '@models/editorState/editorState.model';
import { EditorStateService } from '@services/editorState/editor-state.service';
import { EditorTabsComponent } from '@views/escrito-editor/editor-tabs/editor-tabs/editor-tabs.component';
import { TopMenuComponent } from '@views/escrito-editor/menus/top-menu/top-menu/top-menu.component';
import { ExploradorPanelComponent } from '@views/escrito-editor/sidebar-panels/explorador-panel/explorador-panel/explorador-panel.component';
import { PlantillasPanelComponent } from '@views/escrito-editor/sidebar-panels/plantillas-panel/plantillas-panel/plantillas-panel.component';
import { VariablesPanelComponent } from '@views/escrito-editor/sidebar-panels/variables-panel/variables-panel/variables-panel.component';
import { VersionesPanelComponent } from '@views/escrito-editor/sidebar-panels/versiones-panel/versiones-panel/versiones-panel.component';
import { TinymceEditorComponent } from '@views/escrito-editor/text-editor/tinymce-editor/tinymce-editor.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-editor-layout',
  standalone: true,
  imports: [CommonModule,MatIconModule,MatToolbarModule,MatTooltipModule,TopMenuComponent,EditorTabsComponent,MatButtonModule,EditorTabsComponent,TinymceEditorComponent,ExploradorPanelComponent,VariablesPanelComponent,PlantillasPanelComponent,VersionesPanelComponent],
  templateUrl: './editor-layout.component.html',
  styleUrl: './editor-layout.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorLayoutComponent {

  sidebarWidth = 300;
  private isDragging = false;

  editorState!: EditorState;
  private destroy$ = new Subject<void>();

  constructor(private editorStateService: EditorStateService) {}

  ngOnInit(): void {
    this.editorStateService.getEditorState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.editorState = state;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSidebarToggle(): void {
    this.editorStateService.toggleSidebar();
  }

  onPanelSelect(panel: string): void {
    this.editorStateService.setSidebarPanel(panel as any);
  }

  onNewEscrito(): void {
    this.editorStateService.openTab({
      tipo: 'escrito',
      titulo: 'Nuevo Escrito',
      contenido: ''
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: any): void {
    const hasUnsavedChanges = this.editorState?.tabs?.some(tab => tab.hasChanges);
    if (hasUnsavedChanges) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (this.isDragging) {
      this.sidebarWidth = Math.max(200, Math.min(600, event.clientX - 50));
    }
  }

  @HostListener('mouseup')
  onMouseUp(): void {
    this.isDragging = false;
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  }

  onSplitterMouseDown(event: MouseEvent): void {
    event.preventDefault();
    this.isDragging = true;
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  }
}
